<template>
  <div class="admin">
    <el-container>
      <el-aside width="220px">
        <el-menu :default-active="defaultActiveIndex" class="el-menu-vertical-demo" router>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-s-management"></i>
              <span>内容管理</span>
            </template>
            <el-menu-item index="/admin/enterprises">
              <i class="el-icon-office-building"></i>
              <span slot="title">企业管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/users">
              <i class="el-icon-user"></i>
              <span slot="title">用户管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/services">
              <i class="el-icon-goods"></i>
              <span slot="title">服务商品管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/applications">
              <i class="el-icon-s-check"></i>
              <span slot="title">入驻申请审核</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-s-cooperation"></i>
              <span>企业服务管理</span>
            </template>
            <el-menu-item index="/admin/business-changes">
              <i class="el-icon-document"></i>
              <span slot="title">工商变更申请</span>
            </el-menu-item>
            <el-menu-item index="/admin/transaction-records">
              <i class="el-icon-money"></i>
              <span slot="title">交易记录管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/service-orders">
              <i class="el-icon-shopping-cart-2"></i>
              <span slot="title">服务订单管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/tax-applications">
              <i class="el-icon-s-order"></i>
              <span slot="title">税务代办申请</span>
            </el-menu-item>
            <el-menu-item index="/admin/status-flow-config" v-if="isAdmin">
              <i class="el-icon-s-operation"></i>
              <span slot="title">状态流转配置</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>网站配置</span>
            </template>
            <el-menu-item index="/admin/company-config">
              <i class="el-icon-office-building"></i>
              <span slot="title">公司信息配置</span>
            </el-menu-item>
            <el-menu-item index="/admin/homepage-config">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页配置</span>
            </el-menu-item>
            <el-menu-item index="/admin/announcements">
              <i class="el-icon-message-solid"></i>
              <span slot="title">公告管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/theme-config">
              <i class="el-icon-brush"></i>
              <span slot="title">样式主题配置</span>
            </el-menu-item>
            <el-menu-item index="/admin/menu-config">
              <i class="el-icon-menu"></i>
              <span slot="title">导航菜单配置</span>
            </el-menu-item>
            <el-menu-item index="/admin/footer-config">
              <i class="el-icon-link"></i>
              <span slot="title">底部链接配置</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item index="/admin/files">
            <i class="el-icon-folder-opened"></i>
            <span slot="title">文件管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main class="admin-main">
          <div class="base-padding">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "admin",
  computed: {
    isAdmin() {
      const userRole = localStorage.getItem('userRole')
      return userRole === 'ADMIN' || userRole === 'SUPER_ADMIN'
    },
    defaultActiveIndex() {
      // 如果当前路由是 /admin 或者没有匹配的子路由，则默认选中 /admin/enterprises
      const currentPath = this.$route.path;
      if (currentPath === '/admin' || currentPath === '/admin/' || !this.isActiveRoute(currentPath)) {
        return '/admin/enterprises';
      }
      return currentPath;
    }
  },
  mounted() {
    // 组件挂载完成后，如果当前路径是 /admin，则重定向到 /admin/enterprises
    if (this.$route.path === '/admin' || this.$route.path === '/admin/') {
      this.$router.replace('/admin/enterprises');
    }
  },
  methods: {
    isActiveRoute(path) {
      // 检查当前路径是否是菜单中的一个有效路由
      const validRoutes = [
        '/admin/enterprises',
        '/admin/users',
        '/admin/services',
        '/admin/applications',
        '/admin/business-changes',
        '/admin/transaction-records',
        '/admin/service-orders',
        '/admin/tax-applications',
        '/admin/status-flow-config',
        '/admin/company-config',
        '/admin/homepage-config',
        '/admin/theme-config',
        '/admin/menu-config',
        '/admin/footer-config',
        '/admin/announcements',
        '/admin/files'
      ];
      return validRoutes.some(route => path.startsWith(route));
    }
  }
};
</script>

<style lang="scss" scoped>
.admin {
  height: 100vh;
  /* 使用完整视窗高度 */
  display: flex;
  flex-direction: row;
  /* 显式设置为水平排列，防止受外部样式影响 */
}

/* 使用深度选择器覆盖全局样式，防止打包后被App.vue的全局样式覆盖 */
.admin ::v-deep .el-container {
  height: 100%;
  width: 100%;
  min-height: auto !important;
  /* 覆盖全局的min-height: 100vh */
  flex-direction: row !important;
  /* 强制水平布局，覆盖全局的column */
}

.el-aside {
  background-color: #fff;
  border-right: 1px solid #e6e6e6;
  height: 100%;
  overflow-y: auto;
  box-shadow: 2px 0 6px rgba(0, 21, 41, .05);
}

.admin-main {
  height: 100%;
  /* 确保主内容区域占满高度 */
  padding: 0;
  /* 移除默认内边距 */
}

.base-padding {
  padding: 20px;
  height: 100%;
  /* 让内容填充整个主区域 */
}
</style>

<style>
/* 全局样式 - 头像上传 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>